export const DISCOUNT_STATS_API_PATHNAMES = {
  DISCOUNT_STATS_DATA: ({ startDate, endDate }) =>
    `payments/get/discount/usage/metrics?start_date=${startDate}&end_date=${endDate}`,
};
